import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash' 
import classNames from 'classnames'
import Modal from 'react-modal'

import { getSpecsVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import WeightChooser from 'components/WeightChooser'
import ControlledSelect from 'components/ControlledSelect'
import ControlledRadioGroup from 'components/ControlledRadioGroup'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'

export class SpecsForm extends Component {
  constructor() {
    super();
    this.state = {
      lengthInfoIsOpen: false,
    };
    this.toggleLengthInfo = this.toggleLengthInfo.bind(this);
    this.closeLengthInfo = this.closeLengthInfo.bind(this);
  }
  toggleLengthInfo() {
	if(this.state.lengthInfoIsOpen) {
		this.setState({lengthInfoIsOpen: false});
	} else {
		this.setState({lengthInfoIsOpen: true});	
	}
  }

  closeLengthInfo() {
    this.setState({lengthInfoIsOpen: false});
  }
  componentWillMount(){
    this.props.selectView('FS') 
  }
  render = () => (<div>
    <div className="customize-form-header">Specs</div>
    {this.props.hasWeights &&
    <div className="customize-form-section">
      <div className="customize-form-section-header">Select Weight</div>
        <WeightChooser
          weight={this.props.weight}
          hasEngraving={this.props.hasWeightEngraving}
          isError={this.props.showValidationWarnings && (!this.props.weight.valid)}
          isStampError={this.props.showValidationWarnings}
          isPaintError={this.props.showValidationWarnings}
          onFieldChange={this.props.onFieldChange}
          onSelectStamp={this.props.onSelectStamp}
          onSelectPaintFill={this.props.onSelectPaintFill}
          allowKeepAsIs={!(this.props.buyAPutter && this.props.buyAPutter.selected)}
        />
    </div>
    }
    {this.props.hasTopWeights &&
      <div className="customize-form-section">
        <div className="customize-form-section-header">Select Top Weight</div>
          <WeightChooser
            weight={this.props.topWeight}
            hasEngraving={this.props.hasWeightEngraving}
            isError={this.props.showValidationWarnings && (!this.props.topWeight.valid)}
            isStampError={this.props.showValidationWarnings}
            isPaintError={this.props.showValidationWarnings}
            onFieldChange={this.props.onFieldChange}
            onSelectStamp={this.props.onSelectStamp}
            onSelectPaintFill={this.props.onSelectPaintFill}
            allowKeepAsIs={!(this.props.buyAPutter && this.props.buyAPutter.selected)}
          />
      </div>
    }
    <div className="customize-form-section">
      <div className="customize-form-section-header">Loft</div>
        <ControlledSelect
          selected={this.props.loft.selected}
          options={this.props.loft.options}
          isError={this.props.showValidationWarnings && (!this.props.loft.valid)}
          onChange={partial(this.props.onFieldChange, 'loft')}
        />
    </div>
    <div className="customize-form-section">
      <div className="customize-form-section-header">Lie</div>
        <ControlledSelect
          selected={this.props.lie.selected}
          options={this.props.lie.options}
          isError={this.props.showValidationWarnings && (!this.props.lie.valid)}
          onChange={partial(this.props.onFieldChange, 'lie')}
        />
    </div>
    <div className={classNames('customize-form-section', !this.props.validation.parts.reshaftLength.valid ? 'desired-length-error' : '')}>
      <div className="customize-form-section-header">
		Length <button className="btn-toggle-length-info" onClick={e => this.toggleLengthInfo()} type="button">&#8505;</button>
		
		{(this.state.lengthInfoIsOpen) &&
          <div className="length-info-panel"> 
			<button className="btn-close-length-info" onClick={this.closeLengthInfo} type="button">&times;</button>
			<p>IMPORTANT: Putter length is measured from the butt end of the grip to the bottom center of the putter face. If you are not sure of your putter’s length, please first measure it using this method prior to making your length selections to ensure delivery to your desired specifications.</p>
		  </div>	
	    }
	  </div>
        <ControlledRadioGroup 
			    radioGroup="length"
          selected={this.props.length.selected}
          options={this.props.length.options}
          isError={this.props.showValidationWarnings && !this.props.length.valid}
          onChange={partial(this.props.onFieldChange, 'length')}
        />
        {this.props.length.selected && this.props.length.selected.userSelection &&
          <div className="sub-select">
            <ControlledSelect
              selected={this.props.desiredLength.selected}
              options={this.props.desiredLength.options}
              onChange={partial(this.props.onFieldChange, 'desiredLength')}
            />
          </div>
        }
    </div>
    <div className={
      classNames("customize-form-section", 
                {"hidden":this.props.buyAPutter && this.props.buyAPutter.selected &&
                          this.props.reshaft.options && this.props.reshaft.options.length === 1})}
      >
      <div className="customize-form-section-header">Shaft</div>
        <ControlledSelect
          showPrice={true}
          selected={this.props.reshaft.selected}
          options={this.props.reshaft.options}
          isError={this.props.showValidationWarnings && (!this.props.reshaft.valid)}
          onChange={partial(this.props.onFieldChange, 'reshaft')}
        />
        {this.props.reshaft.selected && this.props.reshaft.selected.gripRequired &&
          <div className="instructional-text">Includes new grip. Cannot reuse old grip.</div>
        }
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Accessories" className="next" to="acc">next: accessories</TrackedButtonLink>
    </div>
    <NavWarning when={!this.props.validation.valid && this.props.validation.parts.reshaftLength.valid}
        message="Please complete all selections above before going to another page." />
    <NavWarning when={!this.props.validation.parts.reshaftLength.valid}
        message="You must select Desired Length when Reshaft is selected." />	
  </div>
  )
}

SpecsForm.defaultProps = {
  hasWeights: false,
  weight: {},
  hasTopWeights: false,
  topWeight: {},
  length: [],
  loft: [],
  lie: [],
  reshaft: [],
  onFieldChange: identity,
  onSelectStamp: identity,
  onSelectPaintFill: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getSpecsVM(state.customize) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid
  return p;
}
const mapDispatchToProps = {
  onFieldChange: actions.selectField,
  onSelectStamp: actions.selectStamp,
  onSelectPaintFill: actions.selectPaintFill,
  selectView: actions.selectView,
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecsForm);